import { isValidLanguageId } from "../utils/I18n";
var AbstractDetector = /** @class */ (function () {
    function AbstractDetector() {
    }
    AbstractDetector.prototype.getName = function () {
        return this.constructor.name;
    };
    /**
     * The detection logic for this class, returns the language string or null when nothing is found.
     *
     * @returns {(string|null)} The language or null if the detector could note validate the language.
     */
    AbstractDetector.prototype.detect = function (language) {
        var lowercaseLanguage = language ? language.toLowerCase() : null;
        if (isValidLanguageId(lowercaseLanguage)) {
            return lowercaseLanguage;
        }
        return null;
    };
    return AbstractDetector;
}());
export default AbstractDetector;
//# sourceMappingURL=AbstractDetector.js.map